import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { ProblemSection } from "./components/sections/ProblemSection";
import { RoadmapSection } from "./components/sections/RoadmapSection";
import { BeforeAfterSection } from "./components/sections/BeforeAfterSection";
import { PainPointsSection } from "./components/sections/PainPointsSection";
import { InsightSection } from "./components/sections/InsightSection";
import { VolumesSection } from "./components/sections/VolumesSection";
import { ResourcesSection } from "./components/sections/ResourcesSection";
import { BonusesSection } from "./components/sections/BonusesSection";
import { OfferSection } from "./components/sections/OfferSection";
import { GuaranteeSection } from "./components/sections/GuaranteeSection";
import { TestimonialsSection } from "./components/sections/TestimonialsSection";
import { AuthorSection } from "./components/sections/AuthorSection";
import { FaqSection } from "./components/sections/FaqSection";
import { FinalCtaSection } from "./components/sections/FinalCtaSection";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white" data-id="element-0" data-mp="4n6a3ahwrb3">
      <MetaPixel data-id="element-1" data-mp="2zllcouynw8jk" />
      <Hero data-id="element-2" data-mp="2zm4xcjfp5b1a" />
      <main data-id="element-3" data-mp="2zmo557bmuj1l">
        <ProblemSection data-id="element-4" data-mp="2zmwhmy3ufmc9" />
        <RoadmapSection data-id="element-5" data-mp="33mouvo46mgny" />
        <BeforeAfterSection data-id="element-6" data-mp="33lwxq8uxsavk" />
        <PainPointsSection data-id="element-7" data-mp="33n6zb810016y" />
        <InsightSection data-id="element-8" data-mp="33oi3h8ycvayl" />
        <VolumesSection data-id="element-9" data-mp="38m1jadapbvsn" />
        <ResourcesSection data-id="element-10" data-mp="38kqbm2e4y3w9" />
        <BonusesSection data-id="element-11" data-mp="38kgmsi4tu2s5" />
        <OfferSection data-id="element-12" data-mp="3dkuuu06fhcq6" />
        <GuaranteeSection data-id="element-13" data-mp="3dle46si0issl" />
        <TestimonialsSection data-id="element-14" data-mp="3dlns8ajhypvn" />
        <AuthorSection data-id="element-15" data-mp="3dirvgpjdy78s" />
        <FaqSection data-id="element-16" data-mp="nvsup6ui4rx0" />
        <FinalCtaSection data-id="element-17" data-mp="nwc1psim5vw9" />
      </main>
      <Footer data-id="element-18" data-mp="nvaszup2llhp" />
      <FloatingCta data-id="element-19" data-mp="nxww9i4xheu4" />
      <PurchasePopup data-id="element-20" data-mp="sudmqizlo5ad" />
    </div>;
}